import { IdentifierType, EMAIL_AND_ID_IDENTIFIER_CONFIG } from 'cio/utils/identifiers';

export const DEMO_ENVIRONMENT_CONFIG = {
  enabledActions: ['push', 'twilio', 'slack', 'in_app'],
  sentAttributes: [
    'id',
    'email',
    'created_at',
    'first_name',
    'last_name',
    'timezone',
    'language',
    'push_allowed',
    'email_allowed',
    'sms_allowed',
  ],
  sentEvents: ['created_account', 'logged_in', 'logged_out'],
  moreAttributes: false,
  moreEvents: false,
  identifierType: IdentifierType.MultiIdentifier,
  identifiers: EMAIL_AND_ID_IDENTIFIER_CONFIG,
};

export const ENVIRONMENT_CONFIGS: Record<string, any> = {
  default: { ...DEMO_ENVIRONMENT_CONFIG },
  inapp: Object.assign({}, { ...DEMO_ENVIRONMENT_CONFIG }),
};

export function getEnvironmentConfig(version?: string | null) {
  if (version == null) {
    return ENVIRONMENT_CONFIGS.default;
  }

  return ENVIRONMENT_CONFIGS[version] ?? ENVIRONMENT_CONFIGS.default;
}
